class DateClass {
  formingDate (val: string|number) {
    let stringVal = val.toString()
    const y = stringVal.slice(0, 4)
    const m = stringVal.slice(4, 6)
    const d = stringVal.slice(6, 8)
    stringVal = `${y}-${m}-${d}T00:00:00`

    let date = new Date(stringVal)
    return date
  }

  adjust (date: Date) {
    return this.formingDate(this.dateToInt(date))
  }

  displayData (val: number) {
    let displayDate = this.formingDate(val).getMonth() + 1 + '月' + this.formingDate(val).getDate() + '日'
    return displayDate
  }

  dateToInt (date: Date) {
    return parseInt(date.toLocaleDateString('sv-SE').replace(/-/g, ''))
  }

  addDate (date: Date, val: number) {
    const newDate = new Date(date.getTime())
    newDate.setDate(newDate.getDate() + val)
    return newDate
  }

  addMonth (date: Date, val: number) {
    const newDate = new Date(date.getTime())
    newDate.setMonth(newDate.getMonth() + val)
    return newDate
  }

  addHour (date: Date, val: number) {
    const newDate = new Date(date.getTime())
    newDate.setHours(newDate.getHours() + val)
    return newDate
  }

  isEqual (date1: Date, date2: Date) {
    return date1.toLocaleDateString('sv-SE') === date2.toLocaleDateString('sv-SE')
  }

  min (a: Date, b: Date) {
    return a < b ? a : b
  }

  max (a: Date, b: Date) {
    return a > b ? a : b
  }

  setWeek (val: number) {
    const week = ['日', '月', '火', '水', '木', '金', '土']
    const weekDay = this.formingDate(val).getDay()

    return week[weekDay]
  }

  /* 月・日を二桁表示(0あり) */
  toDoubleDigits (val: number) {
    var data = val.toString()
    data += ''
    if (data.length === 1) {
      data = '0' + data
    }
    return data
  }

  /* 2つの日付から日数計算 */
  daysCalculation (date1: number, date2: number) {
    var day1 = this.formingDate(date1)
    var day2 = this.formingDate(date2)
    let days = (day2.getTime() - day1.getTime()) / (1000 * 60 * 60 * 24)

    return days
  }

  displayHarvestLimit (limitDay: number) {
    if (limitDay === null || limitDay === undefined || limitDay >= 0) {
      return '収穫適期まで'
    } else {
      return '収穫適期から'
    }
  }

  displayHarvestLimitDay (limitDay: number) {
    if (limitDay === null || limitDay === undefined) {
      return '-日'
    } else if (limitDay >= 0) {
      return limitDay + '日'
    } else if (limitDay <= -20) {
      return '20日以上超過'
    } else {
      return -(limitDay) + '日超過'
    }
  }

  displayHarvestDay (limitDay: number, date: string) {
    if (limitDay !== null && limitDay >= 0 && date !== '') {
      const updateDate = new Date(date.replace(/-/g, '/'))
      if (updateDate.toString() === 'Invalid Date') {
        return ''
      }
      const displayDate = this.toDoubleDigits(updateDate.getMonth() + 1) + '月' + this.toDoubleDigits(updateDate.getDate()) + '日'
      return '(' + displayDate + ')'
    } else {
      return ''
    }
  }

  dateToStringYmd (date: any, unit: string) {
    let formingDate = ''
    if (date !== '' && date !== null && date !== undefined) {
      if (unit === '-') {
        formingDate = this.toDoubleDigits(date.getFullYear()) + '-' + this.toDoubleDigits(date.getMonth() + 1) + '-' + this.toDoubleDigits(date.getDate())
      } else if (unit === 'yyyyMMdd') {
        formingDate = this.toDoubleDigits(date.getFullYear()) + this.toDoubleDigits(date.getMonth() + 1) + this.toDoubleDigits(date.getDate())
      } else if (unit === '年月日') {
        formingDate = this.toDoubleDigits(date.getFullYear()) + '年' + this.toDoubleDigits(date.getMonth() + 1) + '月' + this.toDoubleDigits(date.getDate()) + '日'
      } else if (unit === '年月日時分') {
        formingDate = this.toDoubleDigits(date.getFullYear()) + '年' + this.toDoubleDigits(date.getMonth() + 1) + '月' + this.toDoubleDigits(date.getDate()) + '日 ' + this.toDoubleDigits(date.getHours()) + '時' + this.toDoubleDigits(date.getMinutes()) + '分'
      }
      return formingDate
    }
    return ''
  }

  // '2024-01-12' -> 20240112
  parseInt (date: string) {
    return parseInt(date.replace(/-/g, ''))
  }
}

export default new DateClass()
